//   베이직 학생앱 path 가 그대로 들어와도 통합 path 로 변환해서 일관 처리.
//   매핑 우선순위: 세그먼트 수가 많은 패턴부터 매칭 — `/lecture/:id/:assignmentId` 가 `/lecture/:id` 보다 먼저 검사.

type PathMapping = {
  basicPattern: RegExp
  // String.prototype.replace 용 — query string ($N) 도 그룹으로 보존
  replacement: string
}

export const BASIC_TO_INTEGRATED_PATH_MAPPINGS: PathMapping[] = [
  // QR — 1:1 + query 보존
  { basicPattern: /^\/qr(\?.*)?$/, replacement: '/qr$1' },

  // Workbook — 베이직 상세는 pageNumber 가 없으므로 첫 페이지로 진입
  {
    basicPattern: /^\/student-workbook\/([^/?]+)\/([^/?]+)\/page-list(\?.*)?$/,
    replacement: '/student/student-workbook/detail/$1/$2/1$3',
  },
  {
    basicPattern: /^\/student-workbook\/([^/?]+)\/([^/?]+)(\?.*)?$/,
    replacement: '/student/student-workbook/detail/$1/$2/1$3',
  },
  { basicPattern: /^\/student-workbook(\?.*)?$/, replacement: '/student/student-workbook$1' },

  // Worksheet
  {
    basicPattern: /^\/student-worksheet\/([^/?]+)\/scoring(\?.*)?$/,
    replacement: '/student/student-worksheet/$1/scoring$2',
  },
  {
    basicPattern: /^\/student-worksheet\/([^/?]+)(\?.*)?$/,
    replacement: '/student/student-worksheet/$1$2',
  },
  { basicPattern: /^\/student-worksheet(\?.*)?$/, replacement: '/student/student-worksheet$1' },

  // Exam — 통합앱은 시험지 상세를 scoring 라우트에서 처리
  {
    basicPattern: /^\/student-exam\/([^/?]+)(\?.*)?$/,
    replacement: '/student/student-exam/$1/scoring$2',
  },

  // Lecture — 깊은 패턴 먼저
  {
    basicPattern: /^\/lecture\/([^/?]+)\/([^/?]+)(\?.*)?$/,
    replacement: '/student/lecture/$1/$2$3',
  }, // 출제강의 상세
  { basicPattern: /^\/lecture\/([^/?]+)(\?.*)?$/, replacement: '/student/lecture/$1$2' }, // 강의 상세
  { basicPattern: /^\/lecture(\?.*)?$/, replacement: '/student/lecture/list$1' }, // 강의 리스트

  // Signature workbook — 깊은 패턴 먼저
  {
    basicPattern: /^\/signature-workbook-lecture\/[^/?]+\/([^/?]+)(\?.*)?$/,
    replacement: '/student/lecture/signature-workbook/$1$2',
  },
  {
    basicPattern: /^\/signature-workbook-lecture\/[^/?]+(\?.*)?$/,
    replacement: '/student/lecture/signature-workbook/list$1',
  },

  // Parent — 기존 상세 쿼리는 새 목록 화면으로 수렴
  { basicPattern: /^\/profile\/parent-notice(\?.*)?$/, replacement: '/parent/notice$1' },
]

// ★ 베이직 path 면 통합 path 로 변환, 매핑 없으면 그대로 반환
//   path 인자에는 `/foo?bar=1` 같이 query 도 포함될 수 있고, 그룹 캡처로 보존됨.
export const mapBasicPathToIntegrated = (path: string): string => {
  for (const mapping of BASIC_TO_INTEGRATED_PATH_MAPPINGS) {
    if (mapping.basicPattern.test(path)) {
      return path.replace(mapping.basicPattern, mapping.replacement)
    }
  }
  return path
}
